module.exports = __webpack_public_path__ + "static/media/triangle.099fbfc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/AudienceBuilder/assets/triangle.svg
// module id = 7638
// module chunks = 0